import { Text } from '@theme-ui/components';
import styled from '@emotion/styled';

import { rem } from '@app/styles/theme/layout';

export const CurrentPrice = styled(Text)`
  font-size: ${rem(28)};
  font-weight: 600;
  color: ${({ theme }) => theme.colors?.black};
  display: block;
`;

export const OldPrice = styled(CurrentPrice)`
  color: ${({ theme }) => theme.colors?.gray};
  text-decoration: line-through;
`;
